import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { isLoadingAtom, productAtom } from "./atoms/atoms";
import productApi from "./api/productApi";
import { useAtom, useSetAtom } from "jotai";
import Product from "./components/Product";
import NotFound from "./components/NotFound";
import { orderAtom, showProformaAtom } from "./atoms/atoms";
import ProFormaExitScreen from "./components/ProFormaExitScreen";

function App() {

  const [queryParams, setQueryparam] = useSearchParams();
  const setIsLoading = useSetAtom(isLoadingAtom);
  const [notFound, setNotFound] = useState(false);
  const [product, setProduct] = useAtom(productAtom);
  const productId = queryParams.get('productId');
  const code = queryParams.get('code');
  const setOrder = useSetAtom(orderAtom);
  const [showProforma, setShowProforma] = useAtom(showProformaAtom);
  const [promoCodeMessage, setPromoCodeMessage] = useState(null);

  const setproductId = (productId) => {
    setOrder((prev) => ({
      ...prev,
      productId: productId,
  }));
  }

  const setPromoCodeData = (promoCodeMessage) => {
    setPromoCodeMessage(promoCodeMessage);
    setOrder((prev) => ({
      ...prev,
      promoCode: code,
  }));
  }

  useEffect(() => {
    setIsLoading(true);
 
    if (productId) {
      const getProduct = async () => {
        try {
          let response = await productApi.GetProductById(productId, code);
          if (response.data) {
            if (response.data) {
              setproductId(response.data.product.product_id);
              setPromoCodeData(response.data.promoCodeMessage);
              setProduct(response.data.product);
            } else {
              setNotFound(true);
            }

          } else {
            setNotFound(true);
          }

        } catch (err) {
          setNotFound(true);
        } finally {
          setIsLoading(false);
        }
      }

      getProduct();
    } else {
      setNotFound(true);
      setIsLoading(false);
    }
  }, []);

  if (notFound) {
    return (
      <NotFound />
    );
  } else if (showProforma) {
    return (
      <ProFormaExitScreen />
    );
  } else {
    return (
      <Product product={product} promoCodeMessage={promoCodeMessage} />
    );
  }

}

export default App;
